export default "__VITE_ASSET__bcc9e37c__"